<div class="upload-container" *ngIf="(uploadItems && uploadItems.length > 0) || (downloadItems && downloadItems.length > 0)">
  <div class="file-status-title">
    <span>{{ uploadStatusMessage() }} </span>
    <div class="d-flex file-status-actions">
      <i
        (click)="collapse = !collapse"
        class="ti-chevron-{{ collapse ? 'down' : 'up' }} ti-lg"
        data-bs-toggle="collapse"
        data-bs-target="#collapseOne"
        aria-expanded="true"
        aria-controls="collapseOne"
      >
      </i>
      <i class="ti-close ti-lg" (click)="close()"></i>
    </div>
  </div>
  <div class="remaining-time-cancel-container" *ngIf="!uploadStatus.status; else hasMessage">
    <span></span>
    <span class="cancel-upload" (click)="cancelAllUploadsAndDownloads()"> {{ 'CANCEL' | translate }}</span>
  </div>
  <ng-template #hasMessage>
    <div class="upload-download-complete-status {{ uploadStatus.status }}-message">
      <span class="upload-download-complete-message">{{ uploadStatus.message }}</span>
      <span *ngIf="uploadStatus.status === 'error'" class="retry-upload-download upload-download-complete-message" (click)="retryAllUploadsAndDownloads()">
        {{ 'TRY_AGAIN' | translate }}
      </span>
    </div>
  </ng-template>
  <div id="collapseOne" class="uploads accordion-collapse collapse show" aria-labelledby="headingOne" data-bs-parent="#accordionExample">
    <div class="upload-item" *ngFor="let item of uploadItems">
      <div class="document-info-container">
        <img class="upload-file-icon mr-6" src="/assets/images/suite/storage/upload-file.svg" *ngIf="downloadItems.length > 0 && uploadItems.length > 0" alt="" />
        <img [src]="commonService.getImageUrlByExtension(item)" class="file-thumb" alt="{{ item.fileName }}" title="{{ item.fileName }}" />
        <div class="file-info-container" [ngClass]="{ 'center-file': item.status !== fileUploadState.PENDING }">
          <div class="file-name" [ngStyle]="{ 'font-weight': commonService.containsTurkishCharacters(trimStringPipe.transform(item.fileName, 30)) ? '100' : 'normal' }">
            {{ trimStringPipe.transform(item.fileName, 30) }}
          </div>
          <div class="file-progress" *ngIf="item.status === fileUploadState.PENDING || item.status === fileUploadState.UPLODAING">
            <div [style.width]="getProgress(item) + '%'" [style.maxWidth]="'100%'"></div>
          </div>
        </div>
      </div>
      <div class="document-action d-flex">
        <button *ngIf="item.status === fileUploadState.PENDING || item.status === fileUploadState.UPLODAING" class="btn btn-ghost">
          <img (click)="uploadService.pauseUpload(item.uploadId)" style="cursor: pointer" src="assets/images/suite/storage/pause.svg" alt="" />
        </button>
        <button *ngIf="item.status === 'paused'" class="btn btn-ghost">
          <img (click)="uploadService.resumeUpload(item.uploadId)" style="cursor: pointer" src="assets/images/suite/storage/play.svg" alt="" />
        </button>
        <button
          *ngIf="item.status === fileUploadState.PENDING || item.status === 'paused' || item.status === 'cancelled' || item.status === fileUploadState.UPLODAING"
          class="btn btn-ghost"
          (click)="uploadService.cancelUpload(item.uploadId)"
        >
          <img src="assets/images/suite/storage/close-danger.svg" alt="" />
        </button>
        <button *ngIf="item.status === fileUploadState.UPLOADED || item.status === fileUploadState.COMPLETED" class="btn btn-ghost success">
          <img src="assets/images/suite/storage/check-circle.svg" alt="" />
        </button>
        <button *ngIf="item.status === fileUploadState.FAILED" class="btn btn-ghost retry">
          <img (click)="uploadService.retryUpload(item.uploadId)" src="assets/images/suite/storage/rotate-left.svg" alt="" />
        </button>
      </div>
    </div>
    <div class="upload-item" *ngFor="let item of downloadItems">
      <div class="document-info-container">
        <i *ngIf="downloadItems.length > 0 && uploadItems.length > 0" class="ti-download ti-xl mr-6"></i>
        <img [src]="commonService.getImageUrlByExtension(item)" class="file-thumb" alt="{{ item.fileName }}" title="{{ item.fileName }}" />
        <div class="file-info-container" [ngClass]="{ 'center-file': item.status !== fileDownloadState.PENDING }">
          <div class="file-name">{{ trimStringPipe.transform(item.fileName, 30) }}</div>
          <div class="file-progress" *ngIf="item.status === fileDownloadState.PENDING">
            <div [style.width]="getProgressOfDownload(item) + '%'" [style.maxWidth]="'100%'"></div>
          </div>
        </div>
      </div>
      <div class="document-action d-flex">
        <button *ngIf="item.status === fileDownloadState.PENDING" class="btn btn-ghost">
          <img *ngIf="!item.zippedObject" (click)="downloadService.pauseDownload(item.downloadId)" style="cursor: pointer" src="assets/images/suite/storage/pause.svg" alt="" />
        </button>
        <button *ngIf="item.status === 'paused'" class="btn btn-ghost">
          <img (click)="downloadService.resumeDownload(item.downloadId)" style="cursor: pointer" src="assets/images/suite/storage/play.svg" alt="" />
        </button>
        <button *ngIf="item.status === fileDownloadState.PENDING || item.status === 'paused'" class="btn btn-ghost" (click)="downloadService.cancelDownload(item.downloadId)">
          <img src="assets/images/suite/storage/close-danger.svg" alt="" />
        </button>
        <button *ngIf="item.status === fileDownloadState.DOWNLOADED" class="btn btn-ghost success">
          <img src="assets/images/suite/storage/check-circle.svg" alt="" />
        </button>
        <button *ngIf="item.status === fileDownloadState.FAILED" class="btn btn-ghost retry">
          <img (click)="downloadService.retryDownload(item.downloadId)" src="assets/images/suite/storage/rotate-left.svg" alt="" />
        </button>
      </div>
    </div>
  </div>
</div>
